const name = (animal) => {
    const suffix1 = (animal?.species) ? " - " + animal?.species : '';
    const newName = `${animal.name}${suffix1}`;
    return newName;
}

export { name };
